import Calendar, { CalendarClassNamesType } from './calendar';

export type CalendarClassNames = CalendarClassNamesType;
export default Calendar;
